// The trap administration tables show a stored state as a badge and offer it in
// a select, so both the device and the sample label surfaces read their wording
// from here instead of printing the raw enum. An unknown value falls back to the
// raw enum at the call site, so a newer server's state still renders.

/** A trap device's state, keyed by the stored enum (`trap_device_state`). */
export const TRAP_DEVICE_STATE_LABELS: Record<string, string> = {
	in_service: "In service",
	in_repair: "In repair",
	lost: "Lost",
	retired: "Retired",
};

/** A sample label's state, keyed by the stored enum (`trap_label_state`). */
export const TRAP_LABEL_STATE_LABELS: Record<string, string> = {
	in_service: "In service",
	damaged: "Damaged",
	lost: "Lost",
	retired: "Retired",
};
